import namespace from '@/store/namespace'
export default namespace('Sorteador',{
    actions:[
        'SorteadorLoginOficial',
        'SorteadorLoginDemo',
    ],
})
